import styled from 'styled-components';

export const Body = styled.div`
  line-height: 1rem;
  padding-top: 0.625rem;
`;

export const GroupHeading = styled.div`
  &,
  && > span {
    color: var(--color-neutral__title-active);
    display: flex;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: lighter;
    justify-content: space-between;

    // ItemModifiers is used by the CartItemModal as well as the CheckoutModal and Drawer.
    // Certain elements are displayed differently depending on the location.
    .ant-modal-body & {
      padding-left: 2rem;
    }
  }
`;

export const ItemModifiersGroupTotal = styled.span`
  &&& {
    display: none;

    .ant-modal-body & {
      display: inline-block;
      letter-spacing: 0.5px;
      padding-left: 2rem;
    }
  }
`;

export const Mod = styled.div`
  div.invalid {
    display: flex;
    justify-content: space-between;

    span {
      color: var(--color-error__regular);
    }
  }

  span {
    color: var(--color-neutral__title-active);
    font-size: 0.75rem;
    font-style: normal;
    font-weight: bold;
    line-height: 1rem;

    .ant-modal-body & {
      padding-left: 2rem;
    }
  }
`;
